var map = {
	"./amplify-amazon-button_5.entry.js": [
		990,
		55
	],
	"./amplify-auth-fields_9.entry.js": [
		991,
		56
	],
	"./amplify-authenticator.entry.js": [
		992,
		24
	],
	"./amplify-button_3.entry.js": [
		993,
		57
	],
	"./amplify-chatbot.entry.js": [
		1018,
		17
	],
	"./amplify-checkbox.entry.js": [
		994,
		58
	],
	"./amplify-confirm-sign-in_7.entry.js": [
		995,
		25
	],
	"./amplify-container.entry.js": [
		996,
		59
	],
	"./amplify-federated-buttons_2.entry.js": [
		997,
		60
	],
	"./amplify-federated-sign-in.entry.js": [
		998,
		61
	],
	"./amplify-form-field_4.entry.js": [
		999,
		62
	],
	"./amplify-greetings.entry.js": [
		1000,
		63
	],
	"./amplify-icon-button.entry.js": [
		1001,
		64
	],
	"./amplify-icon.entry.js": [
		1002,
		26
	],
	"./amplify-link.entry.js": [
		1003,
		65
	],
	"./amplify-nav_2.entry.js": [
		1004,
		66
	],
	"./amplify-photo-picker.entry.js": [
		1005,
		67
	],
	"./amplify-picker.entry.js": [
		1006,
		68
	],
	"./amplify-radio-button_2.entry.js": [
		1007,
		27
	],
	"./amplify-s3-album.entry.js": [
		1008,
		28
	],
	"./amplify-s3-image-picker.entry.js": [
		1009,
		29
	],
	"./amplify-s3-image.entry.js": [
		1010,
		30
	],
	"./amplify-s3-text-picker.entry.js": [
		1011,
		31
	],
	"./amplify-s3-text.entry.js": [
		1012,
		32
	],
	"./amplify-select-mfa-type.entry.js": [
		1013,
		69
	],
	"./amplify-sign-in-button.entry.js": [
		1014,
		33
	],
	"./amplify-toast.entry.js": [
		1015,
		70
	],
	"./amplify-tooltip.entry.js": [
		1016,
		71
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 928;
module.exports = webpackAsyncContext;